import { i18n } from '@fs/zion-locale'

export default {
  showAllButton: (itemCount) => i18n.t('expanderList.showAllButton', 'Show all {itemCount}', { itemCount }),
  showLessButton: () => i18n.t('expanderList.showLessButton', 'Show less'),
}
